import { Box } from '@atlaskit/primitives';
import React, { Suspense } from 'react';

import { logoBase64 } from '../../../common/components/logo';
import { useDarkMode } from '../utils/use-dark-mode';
import { useFavicon } from '../utils/use-favicon';

export const LayoutBoysenberry = ({
	children,
	isFullscreen,
}: {
	children: React.ReactNode;
	isFullscreen?: boolean;
}) => {
	useDarkMode();
	useFavicon(logoBase64);

	const suspendedChildren = <Suspense>{children}</Suspense>;

	if (isFullscreen) {
		return suspendedChildren;
	}

	return <Box padding="space.400">{suspendedChildren}</Box>;
};
